import React, { useState } from 'react';
import { doc, setDoc, deleteDoc, writeBatch, updateDoc } from 'firebase/firestore';
import emailjs from '@emailjs/browser';
import * as XLSX from 'xlsx';

// 1. IMPORTAMOS la función centralizada desde el servicio de WhatsApp
import { enviarCredencialesWhatsAppDirecto } from './whatsappService';

export default function AdminPropietarios({
  edificioActual,
  propietarios,
  db,
  nombreColeccion,
  obtenerRegistros
}) {
  const [nuevoDpto, setNuevoDpto] = useState('');
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [nuevoCorreo, setNuevoCorreo] = useState('');
  const [nuevoTelefono, setNuevoTelefono] = useState('');
  const [nuevoPassword, setNuevoPassword] = useState('');
  const [enviandoCorreoId, setEnviandoCorreoId] = useState(null);
  const [enviandoWhatsAppId, setEnviandoWhatsAppId] = useState(null);

  // Estados para la carga masiva y barra de progreso de Excel
  const [procesandoExcel, setProcesandoExcel] = useState(false);
  const [progresoExcel, setProgresoExcel] = useState(0);

  // Estados para el Asistente de Envío Masivo Interactivo (WhatsApp)
  const [enviandoMasivoActivo, setEnviandoMasivoActivo] = useState(false);
  const [indiceMasivoActual, setIndiceMasivoActual] = useState(0);

  // 📧 Estados NUEVOS para el Envío Masivo de Correos por EmailJS
  const [enviandoMasivoCorreoActivo, setEnviandoMasivoCorreoActivo] = useState(false);
  const [progresoCorreoMasivo, setProgresoCorreoMasivo] = useState(0);
  const [totalCorreosEnviadosExito, setTotalCorreosEnviadosExito] = useState(0);

  // Estado para edición
  const [editandoId, setEditandoId] = useState(null);
  const [editDpto, setEditDpto] = useState('');
  const [editNombre, setEditNombre] = useState('');
  const [editCorreo, setEditCorreo] = useState('');
  const [editTelefono, setEditTelefono] = useState('');
  const [editPassword, setEditPassword] = useState('');

  // Prefijo del usuario automático basado en el nombre actual del edificio
  const prefijoEdificio = edificioActual?.nombre ? edificioActual.nombre.toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/g, '') : 'edificio';

  const agregarPropietario = async (e) => {
    e.preventDefault();
    if (!edificioActual) {
      alert("⚠️ Selecciona un edificio primero.");
      return;
    }
    if (!nuevoDpto || !nuevoNombre || !nuevoPassword) {
      alert("⚠️ Por favor completa el Departamento, Nombre y la Contraseña.");
      return;
    }

    try {
      const dptoLimpio = nuevoDpto.trim();
      const idUnico = `dpto_${dptoLimpio.replace(/\s+/g, '_')}`;
      const dptoUsuario = dptoLimpio.toLowerCase().replace(/[^a-z0-9]/g, '');
      const usuarioGenerico = `${prefijoEdificio}${dptoUsuario}`;

      await setDoc(doc(db, nombreColeccion, idUnico), {
        departamento: dptoLimpio,
        nombre: nuevoNombre.trim(),
        correo: nuevoCorreo.trim(),
        telefono: nuevoTelefono.trim(),
        usuario: usuarioGenerico,
        password: nuevoPassword.trim(),
        bloqueadoReservas: false
      });

      setNuevoDpto('');
      setNuevoNombre('');
      setNuevoCorreo('');
      setNuevoTelefono('');
      setNuevoPassword('');
      await obtenerRegistros();
      alert(`✅ Propietario registrado exitosamente.\nUsuario de acceso: ${usuarioGenerico}`);
    } catch (error) {
      console.error("Error al registrar propietario:", error);
      alert("Hubo un error al registrar el propietario.");
    }
  };

  const cambiarEstadoBloqueo = async (propId, estadoActual) => {
    const nuevoEstado = !estadoActual;
    const mensaje = nuevoEstado 
      ? "¿Estás seguro de bloquear el acceso a áreas sociales a este propietario por falta de pago?" 
      : "¿Estás seguro de desbloquear el acceso a áreas sociales a este propietario?";
    
    if (window.confirm(mensaje)) {
      try {
        await updateDoc(doc(db, nombreColeccion, propId), {
          bloqueadoReservas: nuevoEstado
        });
        await obtenerRegistros();
        alert(nuevoEstado ? "🚫 Propietario bloqueado para reservas de áreas sociales." : "✅ Propietario desbloqueado con éxito.");
      } catch (error) {
        console.error("Error al actualizar el estado de bloqueo:", error);
        alert("❌ Hubo un error al actualizar el estado de bloqueo.");
      }
    }
  };

  const descargarPlantillaPropietarios = () => {
    const estructura = [
      { Departamento: "101A", "Nombre Completo": "Juan Pérez", Correo: "juan@email.com", Teléfono: "987654321", Contraseña: "101" },
      { Departamento: "102-B", "Nombre Completo": "María Gómez", Correo: "maria@email.com", Teléfono: "912345678", Contraseña: "102" }
    ];
    const hoja = XLSX.utils.json_to_sheet(estructura);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "PlantillaPropietarios");
    XLSX.writeFile(libro, `Plantilla_Propietarios_${edificioActual?.nombre || 'Edificio'}.xlsx`);
  };

  const manejarExcelPropietarios = (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    
    if (!edificioActual) {
      alert("⚠️ Selecciona un edificio antes de cargar el archivo.");
      e.target.value = null;
      return;
    }

    const lector = new FileReader();
    lector.onload = async (evento) => {
      try {
        setProcesandoExcel(true);
        setProgresoExcel(10);

        const libro = XLSX.read(evento.target.result, { type: 'binary', cellDates: false });
        setProgresoExcel(30);

        const filas = XLSX.utils.sheet_to_json(libro.Sheets[libro.SheetNames[0]], { raw: false });
        setProgresoExcel(50);

        if (filas.length === 0) {
          alert("⚠️ El archivo Excel está vacío o no tiene el formato correcto.");
          setProcesandoExcel(false);
          setProgresoExcel(0);
          return;
        }

        const batch = writeBatch(db);
        let contador = 0;
        const totalFilas = filas.length;

        for (let i = 0; i < totalFilas; i++) {
          let fila = filas[i];
          const dpto = fila['Departamento'] || fila['Dpto'] || fila['departamento'];
          const nombre = fila['Nombre Completo'] || fila['Nombre'] || fila['nombre'];

          if (dpto && nombre) {
            const dptoLimpio = String(dpto).trim();
            const idDoc = `dpto_${dptoLimpio.replace(/\s+/g, '_')}`;
            const dptoUsuario = dptoLimpio.toLowerCase().replace(/[^a-z0-9]/g, '');
            const usuarioGenerico = `${prefijoEdificio}${dptoUsuario}`;
            const passwordLeida = String(fila['Contraseña'] || fila['Password'] || dptoLimpio).trim();

            batch.set(doc(db, nombreColeccion, idDoc), {
              departamento: dptoLimpio,
              nombre: String(nombre).trim(),
              correo: String(fila['Correo'] || fila['Email'] || '').trim(),
              telefono: String(fila['Teléfono'] || fila['Celular'] || '').trim(),
              usuario: usuarioGenerico,
              password: passwordLeida,
              bloqueadoReservas: false
            }, { merge: true });

            contador++;
          }
          const porc = Math.round(50 + ((i + 1) / totalFilas) * 45);
          setProgresoExcel(porc);
        }

        await batch.commit();
        setProgresoExcel(100);
        await obtenerRegistros();

        setTimeout(() => {
          setProcesandoExcel(false);
          setProgresoExcel(0);
        }, 600);

        alert(`✅ ¡Se cargaron y registraron ${contador} propietarios con éxito en el directorio!`);
      } catch (error) {
        console.error("Error al procesar Excel de propietarios:", error);
        alert("❌ Ocurrió un error al procesar el archivo Excel.");
        setProcesandoExcel(false);
        setProgresoExcel(0);
      }
    };
    lector.readAsBinaryString(archivo);
    e.target.value = null;
  };

  const iniciarEdicion = (prop) => {
    setEditandoId(prop.id);
    setEditDpto(prop.departamento || '');
    setEditNombre(prop.nombre || '');
    setEditCorreo(prop.correo || '');
    setEditTelefono(prop.telefono || '');
    setEditPassword(prop.password || '');
  };

  const guardarEdicion = async (idOriginal) => {
    try {
      const dptoLimpio = editDpto.trim();
      const idNuevo = `dpto_${dptoLimpio.replace(/\s+/g, '_')}`;
      const dptoUsuario = dptoLimpio.toLowerCase().replace(/[^a-z0-9]/g, '');
      const usuarioGenerico = `${prefijoEdificio}${dptoUsuario}`;
      
      if (idOriginal !== idNuevo) {
        await deleteDoc(doc(db, nombreColeccion, idOriginal));
      }

      await setDoc(doc(db, nombreColeccion, idNuevo), {
        departamento: dptoLimpio,
        nombre: editNombre.trim(),
        correo: editCorreo.trim(),
        telefono: editTelefono.trim(),
        usuario: usuarioGenerico,
        password: editPassword.trim()
      }, { merge: true });

      setEditandoId(null);
      await obtenerRegistros();
      alert("✅ Propietario actualizado correctamente.");
    } catch (error) {
      console.error("Error al actualizar propietario:", error);
      alert("Hubo un error al actualizar.");
    }
  };

  const eliminarPropietario = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este propietario del directorio?")) {
      try {
        await deleteDoc(doc(db, nombreColeccion, id));
        await obtenerRegistros();
      } catch (error) {
        console.error("Error al eliminar propietario:", error);
        alert("Hubo un error al intentar eliminar el registro.");
      }
    }
  };

  const enviarCredencialesPorCorreo = async (prop) => {
    if (!prop.correo || !prop.correo.includes('@')) {
      alert("⚠️ Este propietario no tiene un correo electrónico válido registrado.");
      return;
    }

    const dptoUsuarioDefault = String(prop.departamento || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const usuarioMostrar = prop.usuario || `${prefijoEdificio}${dptoUsuarioDefault}`;
    const passwordMostrar = prop.password || usuarioMostrar;

    if (window.confirm(`¿Deseas enviar las credenciales de acceso por correo a ${prop.nombre} (${prop.correo})?`)) {
      try {
        setEnviandoCorreoId(prop.id);

        const templateParams = {
          to_email: prop.correo,
          to_name: prop.nombre,
          usuario: usuarioMostrar,
          password: passwordMostrar,
          nombre_edificio: edificioActual?.nombre || 'Edificio MMD&L',
          departamento: prop.departamento
        };

        await emailjs.send(
          'service_kdfys3f',
          'template_6100g0e',
          templateParams,
          'pfJqVpoChzMWTp7L9'
        );

        alert(`✅ Credenciales enviadas exitosamente por correo a ${prop.correo}`);
      } catch (error) {
        console.error("Error al enviar credenciales por EmailJS:", error);
        alert("❌ Hubo un error al enviar el correo a través de EmailJS.");
      } finally {
        setEnviandoCorreoId(null);
      }
    }
  };

  const iniciarEnvioMasivoCorreo = async () => {
    if (!propietarios || propietarios.length === 0) {
      alert("⚠️ No hay propietarios en la lista para enviar correos.");
      return;
    }

    const propietariosConCorreo = propietarios.filter(p => p.correo && p.correo.includes('@'));
    if (propietariosConCorreo.length === 0) {
      alert("⚠️ Ninguno de los propietarios registrados cuenta con un correo electrónico válido (@).");
      return;
    }

    if (window.confirm(`¿Deseas enviar las credenciales de acceso por correo electrónico a ${propietariosConCorreo.length} propietarios del edificio ${edificioActual?.nombre}?`)) {
      try {
        setEnviandoMasivoCorreoActivo(true);
        setProgresoCorreoMasivo(0);
        setTotalCorreosEnviadosExito(0);

        let exitos = 0;
        const total = propietariosConCorreo.length;

        for (let i = 0; i < total; i++) {
          const prop = propietariosConCorreo[i];
          const dptoUsuarioDefault = String(prop.departamento || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          const usuarioMostrar = prop.usuario || `${prefijoEdificio}${dptoUsuarioDefault}`;
          const passwordMostrar = prop.password || usuarioMostrar;

          try {
            const templateParams = {
              to_email: prop.correo,
              to_name: prop.nombre,
              usuario: usuarioMostrar,
              password: passwordMostrar,
              nombre_edificio: edificioActual?.nombre || 'Edificio MMD&L',
              departamento: prop.departamento
            };

            await emailjs.send(
              'service_kdfys3f',
              'template_6100g0e',
              templateParams,
              'pfJqVpoChzMWTp7L9'
            );
            exitos++;
            setTotalCorreosEnviadosExito(exitos);
          } catch (err) {
            console.error(`Error enviando correo a ${prop.correo}:`, err);
          }

          const porcentaje = Math.round(((i + 1) / total) * 100);
          setProgresoCorreoMasivo(porcentaje);
        }

        alert(`✅ ¡Envío masivo de correos finalizado!\n- Correos enviados con éxito: ${exitos} de ${total}`);
      } catch (error) {
        console.error("Error en envío masivo de correos:", error);
        alert("❌ Ocurrió un error durante el proceso masivo de correos.");
      } finally {
        setEnviandoMasivoCorreoActivo(false);
        setProgresoCorreoMasivo(0);
      }
    }
  };

  const enviarCredencialesPorWhatsAppAPI = async (prop) => {
    const telefonoRaw = prop.telefono || prop.celular;
    if (!telefonoRaw || telefonoRaw === '-' || telefonoRaw.trim() === '') {
      alert("⚠️ Este propietario no tiene un número de teléfono/celular registrado.");
      return;
    }

    const dptoUsuarioDefault = String(prop.departamento || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const usuarioMostrar = prop.usuario || `${prefijoEdificio}${dptoUsuarioDefault}`;
    const passwordMostrar = prop.password || usuarioMostrar;
    const nombreEdificio = edificioActual?.nombre || 'Edificio MMD&L';

    if (window.confirm(`¿Enviar aviso por WhatsApp a ${prop.nombre} (${telefonoRaw})?`)) {
      try {
        setEnviandoWhatsAppId(prop.id);

        const resultado = await enviarCredencialesWhatsAppDirecto(
          telefonoRaw,
          prop.nombre,
          prop.departamento,
          usuarioMostrar,
          passwordMostrar,
          nombreEdificio
        );

        if (resultado.success) {
          alert(`✅ ¡Mensaje preparado y abierto con éxito para ${prop.nombre}!`);
        } else {
          throw new Error(resultado.error);
        }
      } catch (error) {
        console.error("Error al enviar WhatsApp:", error);
        alert(`❌ No se pudo procesar el WhatsApp: ${error.message}`);
      } finally {
        setEnviandoWhatsAppId(null);
      }
    }
  };

  const iniciarEnvioMasivo = () => {
    if (!propietarios || propietarios.length === 0) {
      alert("⚠️ No hay propietarios en la lista para enviar mensajes.");
      return;
    }
    setIndiceMasivoActual(0);
    setEnviandoMasivoActivo(true);
  };

  const procesarSiguienteYEnviarMasivo = async () => {
    const prop = propietarios[indiceMasivoActual];
    const telefonoRaw = prop.telefono || prop.celular;

    if (!telefonoRaw || telefonoRaw === '-' || telefonoRaw.trim() === '') {
      alert(`⚠️ El Dpto. ${prop.departamento} (${prop.nombre}) no tiene número registrado. Pasando al siguiente.`);
      avanzarMasivo();
      return;
    }

    const dptoUsuarioDefault = String(prop.departamento || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const usuarioMostrar = prop.usuario || `${prefijoEdificio}${dptoUsuarioDefault}`;
    const passwordMostrar = prop.password || usuarioMostrar;
    const nombreEdificio = edificioActual?.nombre || 'Edificio MMD&L';

    try {
      const resultado = await enviarCredencialesWhatsAppDirecto(
        telefonoRaw,
        prop.nombre,
        prop.departamento,
        usuarioMostrar,
        passwordMostrar,
        nombreEdificio
      );

      if (!resultado.success) {
        console.warn(`Aviso con Dpto ${prop.departamento}: ${resultado.error}`);
      }
    } catch (error) {
      console.error("Error en envío masivo WhatsApp:", error);
    }

    avanzarMasivo();
  };

  const avanzarMasivo = () => {
    if (indiceMasivoActual + 1 < propietarios.length) {
      setIndiceMasivoActual(prev => prev + 1);
    } else {
      setEnviandoMasivoActivo(false);
      alert("🎉 ¡Se ha recorrido todo el directorio de propietarios del edificio con éxito!");
    }
  };

  const propietarioActualMasivo = propietarios[indiceMasivoActual];

  return (
    <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
      <h2 style={{ marginTop: 0, color: '#1e293b' }}>Directorio de Propietarios y Residentes</h2>
      
      {/* SECCIÓN DE CARGA MASIVA MEDIANTE EXCEL */}
      <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '20px', marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px', boxSizing: 'border-box' }}>
        <div>
          <h4 style={{ margin: '0 0 5px 0', color: '#166534' }}>📊 Carga Masiva de Propietarios (Excel)</h4>
          <p style={{ margin: 0, fontSize: '0.85rem', color: '#15803d' }}>Sube una lista completa en formato Excel para registrar múltiples residentes al instante.</p>
        </div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <button type="button" onClick={descargarPlantillaPropietarios} style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' }}>
            📥 Descargar Plantilla Excel
          </button>
          
          <label style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem', display: 'inline-block' }}>
            {procesandoExcel ? '⏳ Procesando...' : '📂 Subir Excel Masivo'}
            <input type="file" accept=".xlsx, .xls, .csv" onChange={manejarExcelPropietarios} style={{ display: 'none' }} disabled={procesandoExcel} />
          </label>
        </div>
      </div>

      {/* SECCIÓN DE ENVÍO MASIVO DE CORREOS ELECTRÓNICOS */}
      <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '20px', marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px', boxSizing: 'border-box' }}>
        <div>
          <h4 style={{ margin: '0 0 5px 0', color: '#1e40af' }}>📧 Envío Masivo de Credenciales por Correo (EmailJS)</h4>
          <p style={{ margin: 0, fontSize: '0.85rem', color: '#1d4ed8' }}>Envía automáticamente las credenciales de acceso a todos los propietarios que tengan correo registrado.</p>
        </div>
        <div>
          <button 
            type="button" 
            onClick={iniciarEnvioMasivoCorreo} 
            disabled={enviandoMasivoCorreoActivo}
            style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
          >
            {enviandoMasivoCorreoActivo ? `⏳ Enviando correos (${progresoCorreoMasivo}%)...` : '✉️ Enviar Correos Masivos a Todos'}
          </button>
        </div>
      </div>

      {/* BARRA DE PROGRESO DE CORREOS MASIVOS */}
      {enviandoMasivoCorreoActivo && (
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '15px', marginBottom: '25px', textAlign: 'center', boxSizing: 'border-box' }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#0369a1' }}>
            ✉️ Enviando credenciales por correo... {progresoCorreoMasivo}% ({totalCorreosEnviadosExito} enviados con éxito)
          </p>
          <div style={{ width: '100%', backgroundColor: '#e2e8f0', borderRadius: '10px', height: '12px', overflow: 'hidden' }}>
            <div style={{ width: `${progresoCorreoMasivo}%`, backgroundColor: '#0284c7', height: '100%', transition: 'width 0.3s ease-in-out' }}></div>
          </div>
        </div>
      )}

      {/* ASISTENTE DE ENVÍO MASIVO INTERACTIVO PARA WHATSAPP */}
      <div style={{ backgroundColor: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '10px', padding: '20px', marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px', boxSizing: 'border-box' }}>
        <div>
          <h4 style={{ margin: '0 0 5px 0', color: '#0369a1' }}>💬 Asistente de Envío Masivo por WhatsApp (Control Directo)</h4>
          <p style={{ margin: 0, fontSize: '0.85rem', color: '#0284c7' }}>Ideal para edificios de más de 80 departamentos. Envía los avisos de forma ordenada sin bloquear tu navegador.</p>
        </div>
        <div>
          {!enviandoMasivoActivo ? (
            <button 
              type="button" 
              onClick={iniciarEnvioMasivo} 
              style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              🚀 Iniciar Envío Masivo WhatsApp ({propietarios.length} Propietarios)
            </button>
          ) : (
            <button 
              type="button" 
              onClick={() => setEnviandoMasivoActivo(false)} 
              style={{ backgroundColor: '#dc2626', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' }}
            >
              ❌ Cerrar Asistente Masivo
            </button>
          )}
        </div>
      </div>

      {/* VENTANA FLOTANTE DEL ASISTENTE MASIVO WHATSAPP */}
      {enviandoMasivoActivo && propietarios.length > 0 && (
        <div style={{ backgroundColor: '#ffffff', border: '2px solid #16a34a', borderRadius: '10px', padding: '20px', marginBottom: '25px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', boxSizing: 'border-box' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
            <span style={{ fontWeight: 'bold', color: '#16a34a', fontSize: '1rem' }}>
              📊 Progreso del Edificio: {indiceMasivoActual + 1} de {propietarios.length}
            </span>
            <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Edificio: {edificioActual?.nombre}</span>
          </div>

          <div style={{ backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0', marginBottom: '15px', boxSizing: 'border-box' }}>
            <p style={{ margin: '0 0 5px 0', fontSize: '1.1rem', fontWeight: 'bold', color: '#0f172a', wordBreak: 'break-word' }}>
              🏢 Departamento: {propietarioActualMasivo?.departamento} — {propietarioActualMasivo?.nombre}
            </p>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.9rem' }}>
              📱 Teléfono registrado: <strong>{propietarioActualMasivo?.telefono || propietarioActualMasivo?.celular || '⚠️ Sin teléfono'}</strong>
            </p>
          </div>

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button 
              type="button"
              onClick={procesarSiguienteYEnviarMasivo}
              style={{ backgroundColor: '#25D366', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', flex: 1, fontSize: '0.95rem' }}
            >
              💬 Abrir WhatsApp y Pasar al Siguiente ➡️
            </button>
            <button 
              type="button"
              onClick={avanzarMasivo}
              style={{ backgroundColor: '#cbd5e1', color: '#334155', border: 'none', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              ⏭️ Saltar este
            </button>
          </div>
        </div>
      )}

      {/* Barra de Progreso de Excel */}
      {procesandoExcel && (
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '15px', marginBottom: '25px', textAlign: 'center', boxSizing: 'border-box' }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#0369a1' }}>⏳ Procesando archivo y guardando residentes en Firebase... {progresoExcel}%</p>
          <div style={{ width: '100%', backgroundColor: '#e2e8f0', borderRadius: '10px', height: '12px', overflow: 'hidden' }}>
            <div style={{ width: `${progresoExcel}%`, backgroundColor: '#0284c7', height: '100%', transition: 'width 0.3s ease-in-out' }}></div>
          </div>
        </div>
      )}

      {/* Formulario de Registro Manual */}
      <form onSubmit={agregarPropietario} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '20px', marginBottom: '25px', boxSizing: 'border-box' }}>
        <h4 style={{ margin: '0 0 15px 0', color: '#0f172a' }}>➕ Registrar Nuevo Propietario (Individual)</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '12px', marginBottom: '15px' }}>
          <input type="text" placeholder="N° Dpto (Ej. 101A)" value={nuevoDpto} onChange={e => setNuevoDpto(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', boxSizing: 'border-box', width: '100%' }} required />
          <input type="text" placeholder="Nombre y Apellido" value={nuevoNombre} onChange={e => setNuevoNombre(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', boxSizing: 'border-box', width: '100%' }} required />
          <input type="email" placeholder="Correo Electrónico" value={nuevoCorreo} onChange={e => setNuevoCorreo(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', boxSizing: 'border-box', width: '100%' }} />
          <input type="text" placeholder="Teléfono / Celular" value={nuevoTelefono} onChange={e => setNuevoTelefono(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', boxSizing: 'border-box', width: '100%' }} />
          <input type="text" placeholder="🔑 Contraseña Portal" value={nuevoPassword} onChange={e => setNuevoPassword(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', boxSizing: 'border-box', width: '100%' }} required />
        </div>
        <button type="submit" style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '9px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Guardar Propietario</button>
      </form>

      {/* Tabla de Propietarios adaptativa */}
      <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', borderRadius: '8px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
        <table className="tabla-propietarios" style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0', color: '#334155' }}>
              <th style={{ padding: '12px 14px' }}>Departamento</th>
              <th style={{ padding: '12px 14px' }}>Nombre Completo</th>
              <th style={{ padding: '12px 14px' }}>Usuario de Acceso</th>
              <th style={{ padding: '12px 14px' }}>Correo</th>
              <th style={{ padding: '12px 14px' }}>Teléfono</th>
              <th style={{ padding: '12px 14px' }}>Contraseña</th>
              <th style={{ padding: '12px 14px' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {propietarios.length === 0 ? (
              <tr><td colSpan="7" style={{ textAlign: 'center', padding: '30px', color: '#666', backgroundColor: '#ffffff' }}>No hay propietarios registrados en este edificio.</td></tr>
            ) : (
              propietarios.map(prop => {
                const dptoUsuarioDefault = String(prop.departamento || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                const usuarioMostrar = prop.usuario || `${prefijoEdificio}${dptoUsuarioDefault}`;
                return (
                  <tr key={prop.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    {editandoId === prop.id ? (
                      <>
                        <td style={{ padding: '10px 14px' }}><input type="text" value={editDpto} onChange={e => setEditDpto(e.target.value)} style={{ width: '100%', padding: '4px', boxSizing: 'border-box' }} /></td>
                        <td style={{ padding: '10px 14px' }}><input type="text" value={editNombre} onChange={e => setEditNombre(e.target.value)} style={{ width: '100%', padding: '4px', boxSizing: 'border-box' }} /></td>
                        <td style={{ padding: '10px 14px' }}><span style={{ fontSize: '0.85rem', color: '#64748b' }}>{`${prefijoEdificio}${editDpto.toLowerCase().replace(/[^a-z0-9]/g, '')}`}</span></td>
                        <td style={{ padding: '10px 14px' }}><input type="email" value={editCorreo} onChange={e => setEditCorreo(e.target.value)} style={{ width: '100%', padding: '4px', boxSizing: 'border-box' }} /></td>
                        <td style={{ padding: '10px 14px' }}><input type="text" value={editTelefono} onChange={e => setEditTelefono(e.target.value)} style={{ width: '100%', padding: '4px', boxSizing: 'border-box' }} /></td>
                        <td style={{ padding: '10px 14px' }}><input type="text" value={editPassword} onChange={e => setEditPassword(e.target.value)} style={{ width: '100%', padding: '4px', boxSizing: 'border-box' }} placeholder="Contraseña" /></td>
                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap' }}>
                          <button onClick={() => guardarEdicion(prop.id)} style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', marginRight: '5px', fontWeight: 'bold' }}>💾 Guardar</button>
                          <button onClick={() => setEditandoId(null)} style={{ backgroundColor: '#64748b', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>❌ Cancelar</button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ padding: '12px 14px' }}><strong>Dpto. {prop.departamento}</strong></td>
                        <td style={{ padding: '12px 14px', wordBreak: 'break-word' }}>{prop.nombre}</td>
                        <td style={{ padding: '12px 14px' }}><code style={{ backgroundColor: '#e0f2fe', color: '#0369a1', padding: '3px 6px', borderRadius: '4px', fontWeight: 'bold' }}>{usuarioMostrar}</code></td>
                        <td style={{ padding: '12px 14px', wordBreak: 'break-all' }}>{prop.correo || '-'}</td>
                        <td style={{ padding: '12px 14px' }}>{prop.telefono || prop.celular || '-'}</td>
                        <td style={{ padding: '12px 14px' }}>
                          <code style={{ backgroundColor: '#f1f5f9', padding: '3px 6px', borderRadius: '4px', color: '#0f172a', fontWeight: 'bold' }}>
                            {prop.password || 'Sin contraseña'}
                          </code>
                        </td>
                        <td style={{ padding: '12px 14px' }}>
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button onClick={() => iniciarEdicion(prop)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem' }} title="Editar">✏️</button>
                            <button onClick={() => eliminarPropietario(prop.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem' }} title="Eliminar">🗑️</button>
                            
                            {/* Botón de Bloqueo / Desbloqueo de Áreas Sociales */}
                            <button 
                              onClick={() => cambiarEstadoBloqueo(prop.id, prop.bloqueadoReservas)}
                              style={{ 
                                backgroundColor: prop.bloqueadoReservas ? '#dc2626' : '#16a34a', 
                                color: 'white', 
                                border: 'none', 
                                padding: '5px 8px', 
                                borderRadius: '4px', 
                                fontSize: '0.7rem', 
                                fontWeight: 'bold', 
                                cursor: 'pointer',
                                whiteSpace: 'nowrap'
                              }}
                              title={prop.bloqueadoReservas ? "Desbloquear reservas de áreas sociales" : "Bloquear reservas por falta de pago"}
                            >
                              {prop.bloqueadoReservas ? '🚫 Bloqueado' : '✅ Activo'}
                            </button>

                            {/* Botón de Correo */}
                            <button 
                              onClick={() => enviarCredencialesPorCorreo(prop)} 
                              style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '5px 8px', borderRadius: '4px', fontSize: '0.7rem', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                              title="Enviar por Correo"
                              disabled={enviandoCorreoId === prop.id}
                            >
                              {enviandoCorreoId === prop.id ? '⏳...' : '✉️ Correo'}
                            </button>

                            {/* Botón de WhatsApp Automático Individual */}
                            <button 
                              onClick={() => enviarCredencialesPorWhatsAppAPI(prop)} 
                              style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '5px 8px', borderRadius: '4px', fontSize: '0.7rem', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}
                              title="Enviar aviso por WhatsApp"
                              disabled={enviandoWhatsAppId === prop.id}
                            >
                              {enviandoWhatsAppId === prop.id ? '⏳ Enviando...' : '💬 WhatsApp Auto'}
                            </button>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}